import type { InputHTMLAttributes } from "react";
import { cx } from "./cx";

export interface SliderProps extends InputHTMLAttributes<HTMLInputElement> {
  /** Render the current value in a mono value chip beside the track. */
  showValue?: boolean;
  /** Format the chip text (e.g. append units). */
  formatValue?: (value: string) => string;
}

/** Range input — radius, opacity, heat-intensity controls (M4). */
export function Slider({ showValue = false, formatValue, className, ...rest }: SliderProps) {
  const display = rest.value != null ? String(rest.value) : String(rest.defaultValue ?? "");
  return (
    <span className={cx("pz-slider", className)}>
      <input type="range" className="pz-slider__input" {...rest} />
      {showValue && <span className="pz-slider__value">{formatValue ? formatValue(display) : display}</span>}
    </span>
  );
}
